import { CivilUnionAnscNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import { Fragment, ReactElement } from 'react';
import ResearchCivilUnionNonResidentAnscNotificationNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-civil-union-non-resident';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchCivilUnionNonResidentAnscNotificationNotificationCivilStatusPage =
  (): ReactElement => {
    return (
      <Fragment>
        <ResearchCivilUnionNonResidentAnscNotificationNotificationCivilStatusShared
          items={CivilUnionAnscNotificationsNonResidentCancellationsCrumbs()}
          scope={IdAmbito.Cancellazioni}
        />
      </Fragment>
    );
  };

ResearchCivilUnionNonResidentAnscNotificationNotificationCivilStatusPage.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default ResearchCivilUnionNonResidentAnscNotificationNotificationCivilStatusPage;
